export const environment = {
  production: true,
  mock: false,
  version: '4.1.14 20260624-111231'
};
